export enum UserPermission {
  BOOKED = 1,
  PORTAL = 2,
  VOUCHER = 3,
}
